import { registerLocaleData } from '@angular/common';
import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { StoreModule } from '@ngrx/store';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { EffectsModule } from '@ngrx/effects';
import { crudReducer } from './store/reducers/crud.reducer';
import { CrudEffect } from './store/effects/crud.effect';
import { authReducer } from './store/reducers/auth.reducer';
import { tableReducer } from './store/reducers/table.reducer';
import { categorieReducer } from './store/reducers/categorie.reducer';
import localeFr from '@angular/common/locales/fr';
import { productReducer } from './store/reducers/product.reducer';
import { prodCommandReducer } from './store/reducers/prod-command.reducer';
import { cardReducer } from './store/reducers/card.reducer';
import { loadDataReducer } from './store/reducers/load-data.reducer';
// import supprimé : NotificationService
import { SharedModule } from './shared/shared.module';
import { localStorageSync } from 'ngrx-store-localstorage';


// Services
import { OnesignalService } from './services/onesignal.service';
import { NotificationHandlerService } from './services/notification-handler.service';
import { VersionInterceptor } from './interceptors/version.interceptor';


registerLocaleData(localeFr);

// Fonction pour persister le state dans localStorage
export function localStorageSyncReducer(reducer: any) {
  return localStorageSync({
    keys: ['auth'], // Persister uniquement l'état auth
    rehydrate: true
  })(reducer);
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    SharedModule,
    StoreModule.forRoot({
      stateCrud: crudReducer,
      auth:authReducer,
      table:tableReducer,
      categorie:categorieReducer,
      product:productReducer,
      prodCommand:prodCommandReducer,
      card:cardReducer,
      loadData:loadDataReducer
    }, {
      metaReducers: [localStorageSyncReducer]
    }),
    EffectsModule.forRoot([CrudEffect])],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: LOCALE_ID, useValue: 'fr-FR'},
    { provide: HTTP_INTERCEPTORS, useClass: VersionInterceptor, multi: true },
    OnesignalService,
    NotificationHandlerService
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
